import { ShaderCanvas } from "@/landing/wab/components/ShaderCanvas";
import {
  SILK_FRAGMENT,
  SILK_SMOOTHING,
  SILK_UNIFORMS,
} from "@/landing/wab/lib/fields/silk";

/**
 * Silk — the recolored (green) wonda.sh WebGL satin field. Absolutely positioned
 * to fill the prefooter card via a className the Prefooter provides.
 */
export function Silk() {
  return (
    <ShaderCanvas
      fragmentShader={SILK_FRAGMENT}
      uniforms={SILK_UNIFORMS}
      smoothing={SILK_SMOOTHING}
    />
  );
}
